import React from 'react'
import { Row, Col, Card, CardHeader, CardBody } from "shards-react";
import formattedDate from "../../utils/formattedDate";


export default function FileTable({ docs }) {
  return (
    <>


      <Row>
        <Col>
          <Card small className="mb-4">
            <CardHeader className="border-bottom">
              <h6 className="m-0">Report History</h6>
            </CardHeader>
            <CardBody className="p-0 pb-3">
              <table className="table mb-0">
                <thead className="bg-light">
                  <tr>
                    <th scope="col" className="border-0">
                      #
                    </th>
                    <th scope="col" className="border-0">
                      Filename
                    </th>
                    <th scope="col" className="border-0">
                      Created At
                    </th>
                    <th scope="col" className="border-0">
                      Download
                    </th>
                  </tr>
                </thead>
                {docs.length > 0 ? (
                  <>
                    {docs && docs.map((doc, index) => (
                      <tbody key={doc.id} >
                        <tr>
                          <td>{index + 1}</td>
                          <td>{doc.filename}</td>
                          <td>{doc.createdAt ? formattedDate(doc.createdAt.seconds) : "loading..."}</td>
                          <td> <a href={doc.url} download> Download PDF</a></td>
                        </tr>
                      </tbody>
                    ))}
                  </>
                ) :
                  (<tbody>
                    <tr>
                      <td>No reports found</td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                  )}
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </>
  )
}
